export default __webpack_public_path__ + "static/media/0065.5add493d.jpg";